import { MaintenanceBanner } from 'components/HubMaintenance/components/MaintenanceBanner'
import { useCheckForHubMaintenance } from 'components/HubMaintenance/utils/useCheckForHubMaintenance'
import type { FC } from 'react'
import React from 'react'
import { LegacyRedirectBanner } from './components/LegacyRedirectBanner'
import { LegacyRedirectBannerMessage } from './components/LegacyRedirectBannerMessage'
import { useRedirectFromLegacyApp } from './utils/useRedirectFromLegacyApp'

export const HubMaintenance: FC<{ children: React.ReactNode }> = ({ children }) => {
  const maintenanceMessage = useCheckForHubMaintenance()
  const showRedirectMessage = useRedirectFromLegacyApp()
  const showMaintenance = maintenanceMessage !== null

  // Both modes render the same div > div > children structure so React never re-parents the app
  // subtree
  return (
    <div
      css={
        showMaintenance
          ? // array value = CSS fallback: 100vh for WebViews without dvh support, 100dvh wins elsewhere
            { display: 'flex', flexDirection: 'column', height: ['100vh', '100dvh'] }
          : { display: 'contents' }
      }
    >
      {showMaintenance && <MaintenanceBanner message={maintenanceMessage} />}
      {/* translateZ(0) makes this wrapper the containing block for the app's many position: fixed
          elements (e.g. Map is fixed with inset 0), so they fill the area below the banner
          instead of the viewport */}
      <div
        css={
          showMaintenance
            ? { position: 'relative', flex: 1, minHeight: 0, transform: 'translateZ(0)' }
            : { display: 'contents' }
        }
      >
        {showRedirectMessage && (
          <LegacyRedirectBanner contained={showMaintenance}>
            <LegacyRedirectBannerMessage />
          </LegacyRedirectBanner>
        )}
        {children}
      </div>
    </div>
  )
}
